exports.MODULES = {
    ALL_MESSAGES: 'ALL_MESSAGES',
    UNASSIGNED: 'UNASSIGNED',
    MY_CONVERSATION: 'MY_CONVERSATION',
    BOT_MESSAGES: 'BOT_MESSAGES'
}